import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as WalletSVG } from "../../../../../../../images/svg/public/order/wallet.svg";

const OrderPaymentSectionHeader = () => {
	const { t } = useTranslation();

	return (
		<section>
			<div className="d-flex flex-column align-items-center gap-2">
				<WalletSVG />
				<h1 className="mb-0">{t("modules.e_order.field.payment.title")}</h1>
			</div>
		</section>
	);
};

export default OrderPaymentSectionHeader;
